import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { useTwitchRemove } from '../../../providers/queries/twitch.mutation';
import LoadAnimateButton from '../../load-animate-button';

function DisconnectTwitch() {
  const { mutate: unlinkTwitchMutation, isPending } = useTwitchRemove();
  const unlinkTwitch = () => {
    unlinkTwitchMutation();
  };

  if (isPending) {
    return (
      <ClickableDiv className="flex w-full items-center justify-center gap-3 text-white">
        <LoadAnimateButton bodySize="text-sm" />
      </ClickableDiv>
    );
  }

  return (
    <ClickableDiv
      className="flex w-full items-center justify-center gap-3 text-white"
      onClick={unlinkTwitch}
    >
      <IcoMoonIcon iconName="twitch" className="size-4" />
      <span className="text-text200 font-semibold">Disconnect Twitch</span>
    </ClickableDiv>
  );
}

export default DisconnectTwitch;
